<template>
  <v-card class="mx-auto" height="100%" flat>
 <v-img src="@/assets/logo-transparent.png"
                  lazy-src="@/assets/logo-transparent.png" width="50%" class="mx-auto mt-2">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="#56BBD8"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
    <v-card-title class="font-weight-bold black--text">
Rani Dental System
    </v-card-title>
    <v-card-subtitle class="overline font-weight-bold black--text">welcome</v-card-subtitle>
    <v-card-text>
      <signinForm />
    </v-card-text>
  </v-card>
</template>

<script>
import signinForm from "./signinForm.vue";
export default {
  data() {
    return {};
  },
  components: { signinForm },
};
</script>

<style scoped>
</style>